import Logo from "../src/assets/img/logo.svg"
// Footer component
function Footer() {
    const year = new Date().getFullYear();
    return (
        <>
            <footer className="footer">
                <div className="container-fix-width">
                    <div className="footer__wrap">
                        <a href="#">
                            <img src={Logo} alt="logo" />
                        </a>
                        <ul className="footer__menu">
                            <li><a href="/faq">Help</a></li>
                            <li><a href="/about">About Us</a></li>
                            <li><a href="/contacts">Contacts</a></li>
                            <li><a href="/settings">Settings</a></li>
                            <li><a href="/terms">Terms of Service</a></li>
                            <li><a href="/privacy-policy">Privacy Policy</a></li>
                        </ul>
                        <p>©<span className="year">{new Date().getFullYear()}</span> SportBeagle. All rights reserved.</p>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer;
